import { useContext, useCallback } from "react"
import API from "./api"

import { NavigationContext } from "web/contexts"

export default function useFieldSuggestedValues(field) {
  const { subjectType } = useContext(NavigationContext) || {}

  const key = `/fields/${field.id}/suggested_values`

  return useCallback(
    async (hint) => {
      return await API.get(key, {
        hint,
        subject_type: subjectType,
      })
    },
    [key, subjectType]
  )
}
